// core/jsx/index.ts

import { EMPTY_STRING } from '@rotomeca/utils';

const VOID_TAGS = new Set([
  'area',
  'base',
  'br',
  'col',
  'embed',
  'hr',
  'img',
  'input',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr',
]);

export function h(tag: any, props: any, ...argsChildren: any[]) {
  if (typeof tag === 'function' && 'TAG' in tag) {
    tag = (tag as any).TAG;
  }

  if (typeof tag === 'function') {
    const children = argsChildren.length ? argsChildren : props?.children || [];
    return tag({ ...props, children });
  }

  let attrs = EMPTY_STRING;
  if (props) {
    for (const key in props) {
      const value = props[key];

      if (key === 'children' || value == null || value === false) continue;

      const name = key === 'className' ? 'class' : key;

      if (key === 'style' && typeof value === 'object') {
        let styleStr = EMPTY_STRING;
        for (const sKey in value) {
          styleStr += `${sKey}:${value[sKey]};`;
        }
        attrs += ` ${name}="${styleStr}"`;
      } else if (value === true) {
        attrs += ` ${name}`;
      } else {
        attrs += ` ${name}="${value}"`;
      }
    }
  }

  const open = `<${tag}${attrs}>`;
  if (VOID_TAGS.has(tag as string)) return open;

  const rawChildren = argsChildren.length > 0 ? argsChildren : props?.children;
  const content = renderChildren(rawChildren);

  return `${open}${content}</${tag}>`;
}

// Helper récursif ultra-rapide pour les enfants
function renderChildren(child: any): string {
  if (child == null || child === false || child === true) return EMPTY_STRING;

  if (Array.isArray(child)) {
    let str = EMPTY_STRING;
    for (let i = 0; i < child.length; i++) {
      str += renderChildren(child[i]);
    }
    return str;
  }

  return String(child);
}

export const Fragment = (props: any) => {
  return props.children ? renderChildren(props.children) : EMPTY_STRING;
};
